import React from "react";

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";

export default function CheckboxChildrenList({ checked, handleChange, sx }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexGrow: 1,
        pl: "12px",
        overflowY: "auto",
        ...sx,
      }}
    >
      {Object.keys(checked).map((name, index) => {
        return (
          <FormControlLabel
            key={index}
            label={name}
            control={
              <Checkbox
                sx={{
                  color: checked[name].color,
                  "&.Mui-checked": {
                    color: checked[name].color,
                  },
                }}
                icon={<CircleOutlinedIcon />}
                checkedIcon={<CircleIcon />}
                checked={checked[name].visible}
                onChange={(event) => handleChange(event, name)}
              />
            }
          />
        );
      })}
    </Box>
  );
}
